<template>
<CDropdown>
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <CIcon class="mx-2" icon="cil-list" size="lg" />
      <CBadge v-if="zadaniaIlosc != '0'" color="danger" position="bottom-start" shape="rounded-pill">
    {{ zadaniaIlosc }} <span class="visually-hidden">aktualnych zadań</span>
  </CBadge>
    </CDropdownToggle>
    <CDropdownMenu v-if="zadaniaIlosc != '0'" class="pt-0 handlink">
      <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
        Najnowsze zadania na dziś - {{ login }}
      </CDropdownHeader>
      <CDropdownItem v-for="(item, index) in zadania" :key="index" @click="ustalLinkDoZadania(item.Guid, item.Type)">
        <CIcon icon="cil-task" /> {{ item.Nazwa }}
        <CBadge color="dark" class="ms-auto">{{ item.Typo }}</CBadge>
      </CDropdownItem>
  </CDropdownMenu>
  </CDropdown>
  
  <CDropdown>
    <CDropdownToggle placement="bottom-end" class="py-0 handlink" :caret="false">
      <CAvatar :src="avatar" size="md" />
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
        Ustawienia - {{ login }}
      </CDropdownHeader>
      <CDropdownItem @click="this.$router.push('/jmp/changePassword');">
        <CIcon icon="cil-shield-alt" /> Zmień hasło
      </CDropdownItem>
      <CDropdownItem @click="resetAllGrid">
        <CIcon icon="cil-code" /> Reset ustawień tabel
      </CDropdownItem>
      <CDropdownItem @click="logout">
        <CIcon icon="cil-lock-locked" /> Wyloguj
      </CDropdownItem>
    </CDropdownMenu>

    <!--<CDropdownMenu class="pt-0">
      <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
        Account
      </CDropdownHeader>
      <CDropdownItem>
        <CIcon icon="cil-bell" /> Updates
        <CBadge color="info" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-envelope-open" /> Messages
        <CBadge color="success" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-task" /> Tasks
        <CBadge color="danger" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-comment-square" /> Comments
        <CBadge color="warning" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownHeader component="h6" class="bg-light fw-semibold py-2">
        Ustawienia
      </CDropdownHeader>
      <CDropdownItem> <CIcon icon="cil-user" /> Profile </CDropdownItem>
      <CDropdownItem> <CIcon icon="cil-settings" /> Settings </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-dollar" /> Payments
        <CBadge color="secondary" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-file" /> Projects
        <CBadge color="primary" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownDivider />
      <CDropdownItem>
        <CIcon icon="cil-shield-alt" /> Lock Account
      </CDropdownItem>
      <CDropdownItem> <CIcon icon="cil-lock-locked" /> Wyloguj </CDropdownItem>
    </CDropdownMenu>-->
  </CDropdown>
</template>

<script>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import avatar from '@/assets/images/avatars/user.jpg'
import { GetAPIData } from "./../tools/getData";
import { ShowError } from "./../tools/message";
import { ResetGridsData, getTaskRoute } from "./../tools/params";

export default {
  name: 'AppHeaderDropdownAccnt',
  setup() {
    const store = useStore()
    return {
      avatar: avatar,
      itemsCount: 42,
      apiData: null,
      zadaniaIlosc: ref("0"),
      zadania: [],
      login: computed(() => store.state.login),
      statusInterval: null,
    }
  },
  created() {
    this.apiData = new GetAPIData();
    this.getStatus();
    this.statusInterval = setInterval(() => {
      this.getStatus();
    }, 30000);
  },
  unmounted() {
    clearInterval(this.statusInterval);
  },
  methods: {
    ustalLinkDoZadania(id, typ) {
      console.log('ustalLinkDoZadania');
      console.log(id);
      console.log(typ);
      const route = getTaskRoute(id, typ);
      if (route) this.$router.push({ path: route });
    },
    getStatus: function () {
      this.apiData.Request("POST", "/api/Zadania/GetStatus", { }).then((data) => {
      if (data.Correct === false) {
        ShowError(data.message);
      } else {
        this.zadaniaIlosc = data.Message;
        this.zadania = data.Data;
        console.log('getStatus');
        console.log(data);
      }
    });
    },
    logout: function () {
      console.log('logout');
      this.apiData.Request("POST", "/api/Auth/logOff", {}).then((data) => {
        if (data.Correct === false) {
          console.log('Error logout');
          ShowError(data.Message);
        } else {
          this.$store.dispatch('loginSystem', { token: '', role: '', login: '' })
          this.$router.push('/');
        }
      });
    },
    resetAllGrid: function () {
      ResetGridsData();
      location.reload();
    },
  },
}
</script>
<style>
.handlink .dropdown-item {
  cursor: pointer;
}
</style>